import { combineReducers } from "@reduxjs/toolkit";
import { sponsorSlice } from "./sponsor/reducers";
import { siteSlice } from "./site/reducers";
import { highlightSlice } from "./highlight/reducers";
import { faqSlice } from "./faq/reducers";
import { areeSlice } from "./aree/reducers";
import { foodSlice } from "./food/reducers";
import { tournamentSlice } from "./tournament/reducers";
import { programmaSlice } from "./programma/reducers";

export const rootReducer = combineReducers({
  sponsor: sponsorSlice.reducer,
  site: siteSlice.reducer,
  faq: faqSlice.reducer,
  highlight: highlightSlice.reducer,
  aree: areeSlice.reducer,
  food: foodSlice.reducer,
  tournament: tournamentSlice.reducer,
  programma: programmaSlice.reducer,
});
